import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { initLenis, destroyLenis } from "@/lib/scroll";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import FloatingCall from "@/components/FloatingCall";
import Home from "@/pages/Home";
import Photos from "@/pages/Photos";
import Quote from "@/pages/Quote";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="relative min-h-screen bg-[#0A0C10] text-white antialiased">
        <div className="grain-overlay" aria-hidden="true" />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/photos" element={<Photos />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Footer />
        <FloatingCall />
        <Toaster position="bottom-left" richColors closeButton />
      </div>
    </BrowserRouter>
  );
}